const round = number => {
	return Math.round(number * 100) / 100;
};

export default ({ height, weight }) => {
	if (height > 0 && weight > 0) {
		return { bmi: round(weight / Math.pow(height / 100, 2)) };
	}
	return { bmi: 0 };
};
